// src/components/common/loader/Loader.tsx

"use client";

import React from "react";
import "./Loader.css";

type LoaderVariant = "circle" | "dots" | "pulse" | "shimmer";
type LoaderColor = "primary" | "glory";
type HorizontalAlign = "left" | "center" | "right";
type VerticalAlign = "top" | "center" | "bottom";
type Direction = "column" | "row";

interface LoaderProps {
  message?: string;
  size?: "sm" | "md" | "lg";
  variant?: LoaderVariant;
  color?: LoaderColor;
  horizontal?: HorizontalAlign;
  vertical?: VerticalAlign;
  direction?: Direction;
  overlay?: boolean;
  fixed?: boolean;
}

const Loader: React.FC<LoaderProps> = ({
  message = "",
  size = "md",
  variant = "circle",
  color = "primary",
  horizontal = "center",
  vertical = "center",
  direction = "column",
  overlay = false,
  fixed = false,
}) => {
  const directionClass = `loader-wrapper-${direction}`;
  const positionClass = `loader-position-${direction}-${vertical}-${horizontal}`;

  const overlayClass = overlay
    ? fixed
      ? "loader-fixed-overlay"
      : "loader-absolute-overlay"
    : "";

  const hasMessage = Boolean(message?.trim());

  return (
    <div
      className={`loader-wrapper ${directionClass} ${positionClass} ${overlayClass}`}
      role="status"
      aria-live="polite"
      aria-label={hasMessage ? message : "Loading"}
    >
      <div className={`loader-content-inner color-${color}`}>
        {variant === "circle" && <div className={`spinner spinner-${size}`} />}

        {variant === "dots" && (
          <div className={`dots-loader dots-${size}`} aria-hidden="true">
            <span />
            <span />
            <span />
          </div>
        )}

        {variant === "pulse" && (
          <div className={`pulse-loader pulse-${size}`} aria-hidden="true" />
        )}

        {variant === "shimmer" && (
          <div className={`shimmer-loader shimmer-${size}`} aria-hidden="true" />
        )}

        {hasMessage && <p className="loader-message">{message}</p>}
      </div>
    </div>
  );
};

export default Loader;

